import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AvailabilityService {
  private availabilityMap: { [key: number]: string } = {
    22: 'Seg M', 23: 'Seg T', 24: 'Seg N',
    32: 'Ter M', 33: 'Ter T', 34: 'Ter N',
    42: 'Qua M', 43: 'Qua T', 44: 'Qua N',
    52: 'Qui M', 53: 'Qui T', 54: 'Qui N',
    62: 'Sex M', 63: 'Sex T', 64: 'Sex N',
    72: 'Sab M', 73: 'Sab T', 74: 'Sab N',
    82: 'Dom M', 83: 'Dom T', 84: 'Dom N'
  };

  getAvailabilityDescription(availability: number[]): string[] {
    return availability?.map(item => this.availabilityMap[item]).filter(Boolean) || [];
  }
}